'use strict';

var Backbone = require('backbone'),

  BackButton = Backbone.View.extend({
    initialize() {
      this.$el.find('a')
        .attr('href', document.referrer);
    }
  }, {
    create($parent) {
    // Create views
      $parent.find('.js-backButton').each(function(n, el) {
        new BackButton({
          el: el
        });
      });
    }
  });

module.exports = BackButton;



// WEBPACK FOOTER //
// ./assets/js/components/backButton.js